var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { Divider as SemanticDivider, } from 'semantic-ui-react';
export function Divider(_a) {
    var { light, dashed, className } = _a, props = __rest(_a, ["light", "dashed", "className"]);
    const classes = cx(className, { light, dashed });
    return React.createElement(SemanticDivider, Object.assign({ className: classes }, props));
}
export default Divider;
//# sourceMappingURL=Divider.js.map